<template>
  <section class="co-bg-striped">
    <div class="co-container-md px-4 py-20 text-center">
      <h3 class="co-display-12 divider mb-5 text-center">
        <span>
          セットは最大
          <!-- 金額の計算が上手くいってないため静的に変更、{{ $addComma(maxBargainPrice) }} -->
          <span class="co-display-10 font-bold text-co-danger-500">55,000</span>
          円もお得！
        </span>
      </h3>
      <div class="flex flex-col justify-center gap-8 md:flex-row ">
        <TeCourseSetBannerPythonDatascience />
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { dateToYesterday, daysOfWeek } from '~/utility/utility'
import TeCourseSetBannerPythonDatascience from '~/components/Te/TeCourse/SetBanner/TeCourseSetBannerPythonDatascience.vue'

interface Methods {
  hours: (date: string) => number
  yesterdayDays: (date: string) => number
  yesterdayMonth: (date: string) => number
  yesterdayDayOfWeek: (
    date: string
  ) => '日' | '月' | '火' | '水' | '木' | '金' | '土'
}

interface Computed {
  closesAt: Date
  yesterdayClosesAt: Date
  closesDays: number
  closesMonth: number
  closesHours: number
  closesDayOfWeek: '日' | '月' | '火' | '水' | '木' | '金' | '土'
  maxBargainPrice: number
}

interface Props {
  firstOpenedWholeCohort: any
  course: any
}

const options = {
  props: {
    firstOpenedWholeCohort: {
      type: Object,
    },
    course: {
      type: Object,
    },
  },
  filters: {
    addComma(value: number) {
      return value.toLocaleString()
    },
  },
  computed: {
    closesAt() {
      return new Date(this.firstOpenedWholeCohort.attributes.closes_at)
    },
    yesterdayClosesAt() {
      return dateToYesterday(this.closesAt)
    },
    closesDays() {
      return this.yesterdayClosesAt.getDate()
    },
    closesMonth() {
      return this.yesterdayClosesAt.getMonth() + 1
    },
    closesHours() {
      return this.yesterdayClosesAt.getHours() + 24
    },
    closesDayOfWeek() {
      const dayOfWeek = daysOfWeek(this.yesterdayClosesAt)
      return dayOfWeek
    },
    maxBargainPrice() {
      if (this.course) {
        const bargainPriceArray = this.course.attributes.packs.map((p: any) => {
          return p.bargain_price
        })
        if (bargainPriceArray.length !== 0) {
          return bargainPriceArray.reduce((a: any, b: any) => {
            return Math.max(a, b)
          })
        } else {
          return 0
        }
      } else {
        return '-'
      }
    },
  },
  methods: {
    hours(date: string) {
      return new Date(date).getHours() + 24
    },
    yesterdayDays(date: string) {
      return dateToYesterday(new Date(date)).getDate()
    },
    yesterdayMonth(date: string) {
      return dateToYesterday(new Date(date)).getMonth() + 1
    },
    yesterdayDayOfWeek(date: string) {
      const yesterday = dateToYesterday(new Date(date))
      const dayOfWeek = daysOfWeek(yesterday)
      return dayOfWeek
    },
  },
  components: {
    TeCourseSetBannerPythonDatascience,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
/* 線のスタイル */
.divider::before,
.divider::after {
  @apply bg-[#a1a1a1] h-px;
}
</style>
